import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'

// local components
import ReportingBroadcast from './ReportingBroadcast'
import InsightsExport from './InsightsExport'
import SyncInsights from './InsightsSync'

export default class InsightsPage extends PureComponent {

  render() {
    const { match } = this.props
    return (
      <Fragment>
        <Route exact path={`${match.url}/broadcast`} component={ReportingBroadcast} />
        <Route exact path={`${match.url}/insightsExport`} component={InsightsExport} />
        <Route exact path={`${match.url}/syncInsightsPermissions`} component={SyncInsights} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Insights/InsightsPage.js